import { EditCommentModal } from 'components/EditCommentModal';
import { type BimActKc2OtherItemData, ProjectStatusEnum } from 'gql/graphql';
import { formatActTitle } from 'pages/Project/Common/ActKc2Title/ActKc2Title';
import { Button, IconEdit, cnMixSpace } from 'uikit';
import { getLengthValidator } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useMemo, useState } from 'react';

import { useSetActKC2OtherCostComment } from '../hooks/useSetActKC2OtherCostComment';

interface IActKC2OtherCostCommentCellRendererComponent extends ICellRendererParams {
    actKc2Other: BimActKc2OtherItemData;
    onUpdateFinish: (isSuccess: boolean) => void;
    statusProject?: ProjectStatusEnum;
    isInactive: boolean;
}

export const ActKC2OtherCostCommentCellRendererComponent = (props: IActKC2OtherCostCommentCellRendererComponent) => {
    const { actKc2Other, statusProject, value: commentValue, data, onUpdateFinish, isInactive } = props;

    const [isModalOpened, setIsModalOpened] = useState(false);
    const toggleModalState = useCallback(() => {
        setIsModalOpened((prev) => !prev);
    }, []);

    const { id: actId, date: actDate, number: actNumber } = actKc2Other;
    const { id: workOrderOtherPriceId, isGroupTitle, isTotalsRow, isExcludedRow } = data;
    const isProjectStatusDelayed = statusProject === ProjectStatusEnum.Delayed;

    const modalTitle = useMemo(() => formatActTitle(actNumber ?? undefined, actDate), [actDate, actNumber]);

    const onSuccess = useCallback(() => {
        toggleModalState();
        onUpdateFinish(true);
    }, [onUpdateFinish, toggleModalState]);

    const { bimSetActKC2OtherCostCommentMakeRequest, isUpdateInProgress } = useSetActKC2OtherCostComment(
        workOrderOtherPriceId,
        actId,
        onSuccess,
    );

    const onChange = useCallback(
        ({ value }: { value: string | null | undefined }) => {
            bimSetActKC2OtherCostCommentMakeRequest(value);
        },
        [bimSetActKC2OtherCostCommentMakeRequest],
    );

    return isGroupTitle || isTotalsRow ? (
        <span />
    ) : (
        <>
            {!isInactive && (
                <Button
                    onClick={toggleModalState}
                    onlyIcon
                    iconRight={IconEdit}
                    size="s"
                    view="ghost"
                    disabled={isProjectStatusDelayed || isExcludedRow}
                    className={cnMixSpace({ mR: 'xs' })}
                />
            )}

            {commentValue?.length ? commentValue : <span style={{ color: 'var(--color-typo-secondary)' }}>—</span>}

            {isModalOpened && (
                <EditCommentModal
                    isOpened
                    modalTitle={modalTitle}
                    defaultValue={commentValue}
                    onClose={toggleModalState}
                    onSubmit={onChange}
                    isCommit={isUpdateInProgress}
                    rules={getLengthValidator(false, 512)}
                    inputLabel="Комментарий"
                />
            )}
        </>
    );
};

ActKC2OtherCostCommentCellRendererComponent.displayName = 'ActKC2OtherCostCommentCellRendererComponent';
